<template>
  <base-form :title="title"
             :loading="submitLoading"
             @submit="submitForm">
    <template v-if="landingPage">
      <div class="flex">
        <div class="px-2">
          <fg-input :label="$t('generic.image')" class="mr-4">
            <image-upload size-type="upload"
                          class="post-image"
                          @on-change="onImageChange"
                          :name="landingPage.title"
                          :src="landingPage.image">
            </image-upload>
          </fg-input>
        </div>
        <div class="flex-1">
          <fg-input :label="$t('generic.seoTitle')"
                    :error="getError($t('generic.seoTitle'))"
                    :name="$t('generic.seoTitle')"
                    :placeholder="$t('generic.seoTitle')"
                    required
                    v-model="landingPage.title"
                    v-validate="'required'">
          </fg-input>
          <fg-input required
                    :label="$t('generic.seoDescription')"
                    :error="getError($t('generic.seoDescription'))">
          <textarea :placeholder="$t('generic.seoDescription')"
                    rows="3"
                    class="form-control"
                    :name="$t('generic.seoDescription')"
                    v-validate="'required'"
                    v-model="landingPage.description">
          </textarea>
          </fg-input>
        </div>
      </div>
      <fg-input :label="$t('generic.jobBoard')"
                :error="getError($t('generic.jobBoard'))"
                required>
        <job-board-autocomplete :placeholder="$t('generic.jobBoard')"
                                :name="$t('generic.jobBoard')"
                                clearable
                                v-validate="'required'"
                                v-model="landingPage.job_board_id">
        </job-board-autocomplete>
      </fg-input>
      <fg-input :label="$t('generic.text')"
                :error="getError($t('generic.text'))"
                :placeholder="$t('generic.text')">
        <wysiwyg :name="$t('generic.text')"
                 class="form-control"
                 :class="{'has-danger': getError($t('generic.text'))}"
                 v-validate="'required'"
                 v-model="landingPage.text">
        </wysiwyg>
      </fg-input>
      <fg-input :label="$t('generic.group')"
                :name="$t('generic.group')"
                :placeholder="$t('generic.group')"
                v-model="landingPage.group">
      </fg-input>
      <section-separator has-border size="lg">
        {{$t('searchSuggestions.list.query')}}
      </section-separator>
      <fg-input :label="$t('generic.segments')">
        <segment-autocomplete :placeholder="$t('generic.segments')"
                              multiple
                              v-model="landingPage.query.segments">
        </segment-autocomplete>
      </fg-input>

      <fg-input :label="$t('searchSuggestions.searchKeywords')">
        <el-select v-model="landingPage.query.search"
                   :placeholder="$t('searchSuggestions.searchKeywords')"
                   filterable
                   multiple
                   allow-create
                   default-first-option
                   class="select-info">
          <el-option :label="$t('searchSuggestions.defaultOption')" value="default" class="select-info"
                     disabled></el-option>
        </el-select>
      </fg-input>
      <fg-input>
        <fg-input v-model="landingPage.query.location"
                  :placeholder="$t('generic.location')"
                  :label="$t('generic.location')">
        </fg-input>
      </fg-input>
    </template>
  </base-form>
</template>
<script>
  import SegmentAutocomplete from 'src/components/Autocomplete/SegmentAutocomplete'
  import JobBoardAutocomplete from 'src/components/Autocomplete/JobBoardAutocomplete'
  import ImageUpload from 'src/components/ImageUpload'
  import Wysiwyg from 'src/components/Wysiwyg/RedactorWysiwyg'
  import { Select, Option } from 'element-ui'

  let defaultQuery = {
    segments: [],
    search: [],
    location: []
  }
  export default {
    components: {
      SegmentAutocomplete,
      JobBoardAutocomplete,
      ImageUpload,
      Wysiwyg,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      data: {
        type: Object,
        default: () => null
      },
      title: String,
      submitLoading: Boolean,
    },
    data () {
      return {
        landingPage: {
          job_board_id: null,
          title: '',
          group: '',
          description: '',
          text: '',
          image: '',
          query: {
            ...defaultQuery
          }
        },
      }
    },
    methods: {
      onImageChange (src) {
        this.landingPage.image = src
      },
      async submitForm () {
        let isFormValid = await this.$validator.validateAll()
        if (!isFormValid) {
          return
        }
        this.$emit('submit', this.landingPage)
      },
      validateQuery (query) {
        let keys = ['segments', 'search', 'location']
        if (!query) {
          return {
            ...defaultQuery
          }
        }
        keys.forEach(key => {
          if (!query[key]) {
            query[key] = []
          }
        })
        return query
      }
    },
    watch: {
      data: {
        immediate: true,
        handler (newVal) {
          if (!newVal) {
            return
          }
          this.landingPage = {
            ...newVal
          }
          this.landingPage.query = this.validateQuery(newVal.query)
        }
      }
    }
  }
</script>
<style>
</style>
